export default __webpack_public_path__ + "static/media/theme-home.0bc82705.svg";